export const getProfile = ({ profile }) => profile

export const isEditing = ({ profile }) => profile.editing

export const getContractedIds = ({ profile }) => profile.contractedIds

export const getStatusLabels = ({ profile }) => profile.statusLabels
